import React, { Component } from 'react';
import {Topic, TextHolder, Footer, ExploreData} from '../../Components/contentHolders/contentHolders.js';

import Highcharts from 'highcharts';


Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});



export class ChapterSixty extends Component {

  render() {
    return (
      <section className="Content">
        <div className="content-holder-topic">
        <div className="content-holder-inner fade">

        <Topic topicNumber={this.props.topicNumber} topicTitle={this.props.topicTitle} topicText={this.props.topicText} />

        <TextHolder text="In popular culture startup founders are often depicted as lone geniuses working on their own to achieve visionary goals. But really, who are they? What makes them tick?" />



        <ExploreData nextChapter={ this.props.nextChapter } />
        <Footer />
        </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/60.js